import { sidebarUrlParamsSchema } from "@grafit/shared/utils/sidebar-url-params-schema";
import { tidSchemaFactory } from "@grafit/shared/utils/validation";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { TaskListPage } from "../../../features/task-list/task-list-page";

const tasksRouteSearchSchema = sidebarUrlParamsSchema.extend({
  selectedTaskId: tidSchemaFactory("task").optional(),
});

export const Route = createFileRoute("/_auth/_project/tasks/$projectId/$subProjectId")({
  component: TaskListPage,
  validateSearch: zodValidator(tasksRouteSearchSchema),
});
